import { type ReactNode, useMemo } from 'react'
import { pipe, map, splitEvery } from 'ramda'

import toFixedValue from 'app/common/lib/toFixedValue'
import { SummaryItem, SummaryWrap } from 'app/components/common/reports/summary'

import type { SummaryCamp as SummaryType } from '../types'

const convertToString = (val: number | void, currency: string) => {
  return typeof val === 'number' ? `${toFixedValue(val)} ${currency}` : '—'
}

type Props = {
  summary: SummaryType
  currency: string
  excludeOVZ?: boolean
  showCount?: boolean
  itemClassName?: string
}

const SummarySpecialCustom = ({
  summary,
  currency,
  excludeOVZ,
  showCount,
  itemClassName,
}: Props): ReactNode => {
  const rows = useMemo(() => {
    return pipe(
      map(({ title, sum, count }) => [
        title,
        showCount
          ? [convertToString(sum, currency), String(count)]
          : [convertToString(sum, currency)],
      ]),
      splitEvery(3),
    )(summary)
  }, [summary, currency, showCount])

  return (
    <SummaryWrap>
      {rows.map((row, i) =>
        row.map(([title, value]: any) => (
          <SummaryItem key={title} className={itemClassName} title={title} value={value} />
        )),
      )}
    </SummaryWrap>
  )
}

export default SummarySpecialCustom
